import { render, staticRenderFns } from "./circle-editor.vue?vue&type=template&id=52851e00&scoped=true&"
import script from "./circle-editor.vue?vue&type=script&lang=js&"
export * from "./circle-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52851e00",
  null
  
)

export default component.exports